import { render, staticRenderFns } from "./useDialog.vue?vue&type=template&id=28fd5a9c&scoped=true"
import script from "./useDialog.vue?vue&type=script&lang=js"
export * from "./useDialog.vue?vue&type=script&lang=js"
import style0 from "./useDialog.vue?vue&type=style&index=0&id=28fd5a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd5a9c",
  null
  
)

export default component.exports